module.exports = __webpack_public_path__ + "img/zhedie.bd7802dc.svg";